// extracted by mini-css-extract-plugin
export var accordion = "_bg-0";
export var chevron = "_bg-3";
export var closed = "_bg-2";
export var content = "_bg-4";
export var open = "_bg-1";
export var rotate = "_bg-5";